
import React from "react";
import HomeWhoAreWe from "./HomeWhoAreWe";

const cards = [
  {
    header:
      "Choose For Many Fabrics and Textiles materials for your production",
    details: "We classified it on the basis of material, design and by craft.",
  },
  {
    header:
      "Create Your Design Only for the Fabric Production and Natural Fabrics",
    details: "With its rapid growth over the last six years, since 2017",
  },
  {
    header:
      "Shoose from various fabric types that are stretchy and comfortable.",
    details: "The Dynamic Exim is a leading export textile service globally.",
  },
];

const HomeProduction = () => {
  return (
    <div className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          Manufacturing Standards
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 leading-tight">
          WE GIVE TOP PRODUCTION <br />
          FROM EVERY ANGLE.
        </h2>
      </div>

      <div
        className="grid gap-8 md:grid-cols-2 lg:grid-cols-3"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {cards.map((c, i) => (
          <div
            key={i}
            className="group relative p-8 rounded-2xl bg-white border border-slate-200/80 shadow-sm hover:shadow-xl hover:border-slate-300 transition-all duration-300 hover:-translate-y-1.5 flex flex-col justify-between"
          >
            <div>
              <div className="flex items-center justify-between mb-6">
                <span className="text-4xl font-extrabold text-slate-200 group-hover:text-[#EB4438] transition-colors duration-300">
                  0{i + 1}
                </span>
                <span className="w-8 h-1 rounded-full bg-slate-100 group-hover:bg-[#EB4438] transition-colors duration-300"></span>
              </div>
              <h3 className="font-bold text-slate-800 text-lg leading-snug mb-3">
                {c.header}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed">{c.details}</p>
            </div>
            <div className="mt-6 pt-4 border-t border-slate-100 flex items-center text-xs font-semibold text-[#EB4438]">
              <span className="group-hover:translate-x-1 transition-transform duration-200 inline-flex items-center gap-1">
                Reliable Quality &rarr;
              </span>
            </div>
          </div>
        ))}
      </div>
      <HomeWhoAreWe />
    </div>
  );
};

export default HomeProduction;
